import { FuseLayoutConfigs } from "@fuse";
import _ from "@lodash";
import { FormControl, FormControlLabel, FormLabel, MenuItem, Paper, Radio, RadioGroup, Select, Switch, Typography, withStyles } from "@material-ui/core";
import * as AuthActions from "app/Core/Funcionalidade/Auth/store/actions";
import FirebaseAuthService from "app/Core/services/FirebaseAuthService";
import * as Actions from "app/store/actions";
import clsx from "clsx";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const styles = theme => ({
    root: {},
    formControl: {
        margin: "0",
        width: "100%",
        "&:last-child": {
            marginBottom: 0
        }
    },
    group: {},
    formGroupTitle: {
        position: "absolute",
        top: -10,
        left: 8,
        fontWeight: 600,
        padding: "0 4px",
    },
    formGroup: {
        position: "relative",
        border: "1px solid " + theme.palette.divider,
        borderRadius: 2,
        padding: "12px 12px 0 12px",
        margin: "24px 0 16px 0",
        "&:first-of-type": {
            marginTop: 16
        }
    },
    paper: {
        border: "1px solid " + theme.palette.divider,
        backgroundColor: theme.palette.background.paper
    },
    spanlabel: {
        top: 9,
        left: 15,
        position: "relative",
        paddingRight: 5,
        paddingLeft: 5,
        fontSize: 12.5,
        fontFamily: "Muli,Roboto,'Helvetica',Arial,sans-serif",
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
        maxWidth: 52,
    }
});

class FuseSettings extends Component {

    handleChange = (event) => {

        var newSettings = _.set(_.merge({}, this.props.settings), "theme.main", event.target.value);
        newSettings = _.set(_.merge({}, newSettings), "theme.toolbar", event.target.value);
        newSettings = _.set(_.merge({}, newSettings), "theme.footer", event.target.value);
        newSettings = _.set(_.merge({}, newSettings), "theme.navbar", event.target.value);

        /**
         * If layout style changes,
         * Reset Layout Configuration
         */
        if (event.target.name === "layout.style" && event.target.value !== this.props.settings.layout.style) {
            newSettings.layout.config = {};
        }

        this.props.setDefaultSettings(newSettings);

        // if ( this.props.user.role === "guest" )
        // {
        //     this.props.setDefaultSettings(newSettings);
        // }
        // else
        // {
        //     this.props.updateUserSettings(newSettings);
        // }
    };

    render() {
        const { classes, settings, themes, setTema, setLayout } = this.props;

        function ThemeSelect({ value, name, handleChange }) {
            setTema(value);
            sessionStorage.setItem("theme", FirebaseAuthService.getTheme(value).palette.primary.main);
            sessionStorage.setItem("themetype", FirebaseAuthService.getTheme(value).palette.type);

            return (
                <Select
                    className="w-full"
                    value={value}
                    onChange={handleChange}
                    name={name}
                >
                    {Object.entries(themes).map(([key, val]) => (
                        <MenuItem
                            key={key} value={key}
                            className="m-8 mt-0 rounded-lg"
                            style={{
                                backgroundColor: val.palette.background.default,
                                color: val.palette.text.primary,
                                border: "1px solid " + val.palette.divider
                            }}
                        >
                            {_.startCase(key)}
                            <div
                                className="flex w-full h-8 block absolute pin-b pin-l pin-r"
                                style={{
                                    borderTop: "1px solid " + val.palette.divider
                                }}
                            >
                                <div className="w-1/4 h-8" style={{ backgroundColor: val.palette.primary.main }} />
                                <div className="w-1/4 h-8" style={{ backgroundColor: val.palette.secondary.main }} />
                                <div className="w-1/4 h-8" style={{ backgroundColor: val.palette.error.main }} />
                                <div className="w-1/4 h-8" style={{ backgroundColor: val.palette.background.paper }} />
                            </div>
                        </MenuItem>
                    ))}
                </Select>
            );
        }

        const LayoutSelect = () => {
            return (
                <FormControl component="fieldset" className={classes.formControl}>
                    <FormLabel component="legend" className="text-14">Style</FormLabel>
                    <RadioGroup
                        aria-label="Layout Style"
                        name="layout.style"
                        className={classes.group}
                        value={settings.layout.style}
                        onChange={this.handleChange}
                    >
                        {Object.entries(FuseLayoutConfigs).map(([key, layout]) => (
                            <FormControlLabel key={key} value={key} control={<Radio />} label={layout.title} />
                        )
                        )}
                    </RadioGroup>
                </FormControl>
            );
        };

        const getForm = (form, prefix) => {
            return Object.entries(form).map(([key, formControl]) => {
                const target = prefix ? prefix + "." + key : key;
                switch (formControl.type) {
                    case "radio":
                        {
                            return (
                                <FormControl key={target} component="fieldset" className={classes.formControl}>
                                    <FormLabel component="legend" className="text-14">{formControl.title}</FormLabel>
                                    <RadioGroup
                                        aria-label={formControl.title}
                                        name={`layout.config.${target}`}
                                        className={classes.group}
                                        value={_.get(settings.layout.config, target)}
                                        onChange={this.handleChange}
                                        row={formControl.options.length < 4}
                                    >
                                        {formControl.options.map((opt) => (
                                            <FormControlLabel key={opt.value} value={opt.value} control={<Radio />} label={opt.name} />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            );
                        }
                    case "switch":
                        {
                            return (
                                <FormControl key={target} component="fieldset" className={classes.formControl}>
                                    <FormControlLabel
                                        classes={{
                                            // root: "flex-row-reverse justify-end pl-16"
                                        }}
                                        control={
                                            <Switch
                                                name={`layout.config.${target}`}
                                                checked={_.get(settings.layout.config, target)}
                                                onChange={this.handleChange}
                                                aria-label={formControl.title}
                                            />
                                        }
                                        label={<FormLabel component="legend" className="text-14">{formControl.title}</FormLabel>}
                                    />
                                </FormControl>
                            )
                        }
                    case "group":
                        {
                            return (
                                <div key={target} className={classes.formGroup}>

                                    <Typography className={classes.formGroupTitle} color="textSecondary">
                                        {formControl.title}
                                    </Typography>

                                    {
                                        getForm(formControl.children, key)
                                    }
                                </div>
                            );
                        }
                    default:
                        {
                            return ""
                        }
                }
            });
        };

        const LayoutConfig = () => {
            const form = FuseLayoutConfigs[settings.layout.style].form;
            return getForm(form);
        };

        return (
            <div className={classes.root}>
                {setTema &&
                    <div className="w-full mb-16 flex flex-col">
                        <span className={classes.spanlabel}>{"Tema *"}</span>
                        <Paper className={clsx(classes.paper, "p-16 flex w-full cursor-pointer")} elevation={0} rounded={true} onClick={this.onChangeMenu} >
                            <FormControl component="fieldset" className={classes.formControl}>
                                <ThemeSelect value={settings.theme.main} name="theme.main" handleChange={this.handleChange} />
                            </FormControl>
                        </Paper>
                    </div>
                }
                {setLayout &&
                    <div className={classes.formGroup}>
                        <Typography className={classes.formGroupTitle} color="textSecondary">
                            Layout
                        </Typography>
                        <LayoutSelect />
                    </div>
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setDefaultSettings: Actions.setDefaultSettings,
        updateUserSettings: AuthActions.updateUserSettings
    }, dispatch);
}

function mapStateToProps({ fuse, auth }) {
    return {
        settings: fuse.settings.current,
        themes: fuse.settings.themes,
        user: auth.user
    }
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(FuseSettings));
